import { useEffect, useState } from "react";

import { notifications } from "@mantine/notifications";
import { Input, Modal, ModalActions, ModalContent, ModalTitle } from "@onengine/component-library";

import { Button } from "@/components/ui/Button/Button.tsx";
import { useFileManager, useFileManagerUI } from "@/components/core/FileManager";
import { modalBody } from "@/components/features/FileManager/Modals/modals.style.ts";

export function CreateFolderModal() {
  const { createFolder } = useFileManager();
  const { isCreateFolderOpen, closeCreateFolder } = useFileManagerUI();
  const [name, setName] = useState("New Folder");

  useEffect(() => {
    if (isCreateFolderOpen) setName("New Folder");
  }, [isCreateFolderOpen]);

  function handleCreate() {
    createFolder(
      { name },
      {
        onSuccess: closeCreateFolder,
        onError: () => {
          notifications.show({
            title: "Create failed",
            message: "Could not create folder. Please try again.",
            color: "red",
            autoClose: 4000,
          });
        },
      },
    );
  }

  return (
    <Modal open={isCreateFolderOpen} onClose={closeCreateFolder}>
      <ModalContent>
        <ModalTitle>New folder</ModalTitle>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleCreate();
          }}
        >
          <div style={modalBody}>
            <Input label="Folder name" value={name} onChange={setName} />
            <ModalActions position={"right"}>
              <Button type="button" variant="neutral-secondary" onClick={closeCreateFolder}>
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                Create
              </Button>
            </ModalActions>
          </div>
        </form>
      </ModalContent>
    </Modal>
  );
}
